import React, { useState, useEffect } from "react";

import "../css/PopupCP.css";

import { post } from "../../js/post";

import { userData } from "../../js/utils";

import ButtonIconH from "../../components/ButtonIconH";

export default ({ show, direccion, localidad, onAccept, onCancel }) => {
  const [fullAddress, setFullAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");

  const loadPopup = async () => {
    setLoaded(true);

    if (direccion.trim() === "" || !direccion) {
      setError("Es necesario introducir dirección para obtener código postal.");
      return;
    }

    if (localidad.trim() === "" || !localidad) {
      setError("Es necesario introducir localidad para obtener código postal.");
      return;
    }

    const address = direccion + " " + localidad;
    const response = await post("ObtenerCodigoPostalGoogle.php", {
      token: userData.token,
      direccion: address,
    });
    if (response.cp !== "") {
      setFullAddress(response.direccionCompleta);
      setPostalCode(response.cp);
    } else {
      setError("No se pudo obtener código postal.");
    }
  };

  const onCancelPopup = () => {
    setLoaded(false);
    setFullAddress("");
    setPostalCode("");
    setError("");
    if (onCancel) {
      onCancel();
    }
  };

  const onAcceptPopup = () => {
    setLoaded(false);
    setFullAddress("");
    setPostalCode("");
    setError("");
    if (onAccept) {
      const fAddress = {
        fullAddress,
        postalCode,
      };
      onAccept(fAddress);
    }
  };

  useEffect(() => {
    if (show) {
      loadPopup();
    }
  }, [show]);

  return loaded && (error !== "" || postalCode !== "") ? (
    <div className="popup-container popup-normal popup-cp">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Búsqueda de código postal</div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={onCancelPopup}
          />
        </div>
        {error === "" && (
          <div className="popup-body">
            <div className="popup-body-agent">
              <span className="popup-body-agent">Dirección completa</span>
              <span>{fullAddress}</span>
            </div>
            <div className="popup-body-agent">
              <span className="popup-body-agent">Código postal</span>
              <span>{postalCode}</span>
            </div>
          </div>
        )}
        {error !== "" && (
          <div className="popup-body">
            <div className="popup-body-agent">
              <span>{error}</span>
            </div>
          </div>
        )}
        <div className="popup-footer">
          <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
            <div className="popup-row-buttons">
              <ButtonIconH text="Cancelar" onClick={onCancelPopup} />
              {error === "" && (
                <ButtonIconH
                  text="Añadir código postal"
                  onClick={onAcceptPopup}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
